module.exports = __webpack_public_path__ + "img/2.65d24ac0.jpg";